<footer class="footer-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="content">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/images/logo2.png" alt="logo" /></a>
                    </div>
                    <p>Sri Bala Sai Degree College is a premier institution committed to providing quality higher
                        education and fostering intellectual and personal growth</p>

                    <ul class="footer-list foot-social">
                        <li><a href="tel:+917942683769"><i class="bx bx-mobile-alt"></i> +91 7942683769</a></li>
                        <li><a href="mailto:sribalasaidegreecollege&#64;gmail.com"><i class="bx bxs-envelope"></i> sribalasaidegreecollege&#64;gmail.com</a>
                        </li>
                    </ul>
                   
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="content ml-15">
                    <h3>Our Campus Provides</h3>

                    <ul class="footer-list">
                        <li><a routerLink="/">Library</a></li>
                        <li><a routerLink="/">Labs</a></li>
                        <li><a routerLink="/">Bus Facility</a></li>
                        <li><a routerLink="/">Experienced Faculty</a></li>
                        <li><a routerLink="/">100% Placement</a></li>
                        <li><a routerLink="/">Good Knowledge</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6">
                <div class="content">
                    <h3>Quick Links</h3>

                    <ul class="footer-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/about">About</a></li>
                        <li><a routerLink="/courses">Courses</a></li>
                        <li><a routerLink="/admissions">Admissions</a></li>
                        <li><a routerLink="/placements">Placements</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="content contacts">
                    <h3 class="ml-40">Contact</h3>

                    <ul class="footer-list foot-social">
                        <li><a href="tel:+917942683769"><i class="bx bx-mobile-alt"></i> +91 7942683769</a></li>
                        <!-- <li><a href="tel:+1975456789"><i class="bx bx-phone"></i> +1 975 456 789</a></li> -->
                        <li><a href="mailto:sribalasaidegreecollege&#64;gmail.com"><i class="bx bxs-envelope"></i> sribalasaidegreecollege&#64;gmail.com</a>
                        </li>
                        <li><i class="bx bxs-map"></i> 27-255, Fort Road,Machilipatnam.</li>
                    </ul>
                     <ul class="social">
                        <li><a href="https://www.facebook.com/SBSDCMachilipatnam/" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.twitter.com/" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="https://www.instagram.com/sri_bala_sai_degree_college/" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://in.linkedin.com/school/sri-balasai-degree-college/" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copy-area" style="margin-top: 0px;">
        <div class="container">
            <div style="text-align: center;">
                <p>©  Sri Bala Sai Degree College is Proudly Owned by  <a href="https://godavariwave.com/" target="_blank">Godavari Wave</a></p>
                <a href="home" title="website counters"><img src="https://counter6.optistats.ovh/private/freecounterstat.php?c=xdf2wmgqpw8t9r7b9j1l4b4875wft3c6" border="0" title="website counters" alt="website counters"></a>
            </div>
        </div>
    </div>
</footer>

<div class="go-top">
    <i class='bx bx-chevrons-up'></i>
    <i class='bx bx-chevrons-up'></i>
</div>